import React from 'react';
import { ChatPanel } from '../components/chat/ChatPanel';
import { useStore } from '../store';
import { t } from '../lib/i18n';

export const ChatsPage: React.FC = () => {
  const { lang } = useStore();
  return (
    <div className="page-container" style={{ paddingBottom: 0 }}>
      <div className="section-header">
        <h2>{t(lang, 'chat_title')}</h2>
      </div>
      <ChatPanel />
    </div>
  );
};
